import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=b00e0cee&scoped=true&"
import script from "./Folders.vue?vue&type=script&lang=js&"
export * from "./Folders.vue?vue&type=script&lang=js&"
import style0 from "./Folders.vue?vue&type=style&index=0&id=b00e0cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00e0cee",
  null
  
)

export default component.exports